import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 10 10",
  height: "48",
  width: "48",
  xmlns: "http://www.w3.org/2000/svg",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M9.794,6.607,5.884,2.49A1.255,1.255,0,0,0,4.1,2.5l-3.9,4.1A.75.75,0,1,0,1.294,7.641L4.819,3.928a.249.249,0,0,1,.362,0L8.706,7.641A.75.75,0,1,0,9.794,6.607Z",
      fill: "currentColor",
      stroke: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "0"
    }, null, -1)
  ])))
}
export default { render: render }